"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _tabs.default;
  }
});
var _tabs = _interopRequireDefault(require("./tabs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }